import { inject, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { environment } from '../../../environments/environment';

export type LogSeverityLevel = 'fatal' | 'error' | 'warning' | 'log' | 'debug' | 'info';

export const CommonLogMessages = {
  AutoLogout: 'auto logout',
  Unauthorized: 'error-401',
  TokenExpired: 'token-expired',
};

@Injectable({
  providedIn: 'root',
})
export class LogService {
  setUser(userId: string | null) {
    if (!environment.sentry.enabled) {
      return;
    }
    if (userId) {
      Sentry.setUser({
        id: userId,
      });
    } else {
      Sentry.setUser(null);
    }
  }

  logMessage(level: LogSeverityLevel, message: string, data?: any) {
    console.log('level:', level, ';message:', message, ';data:', data);
    if (environment.sentry.enabled) {
      Sentry.captureMessage(message, {
        level,
        extra: data,
      });
    }
  }

  logError(message: Error, data?: any) {
    if (environment.sentry.enabled) {
      Sentry.captureException(message, {
        extra: data,
      });
    }
  }
}
